import { CheckSolidIcon, TimesIcon } from '../../assets/icons/common';
import styles from './style.module.scss';

interface Props {
    title: string;
    action?: any;
};

function Tag(props: Props) {
    const { title, action } = props;

    return (
        <div className={styles.wrapper}>
            <CheckSolidIcon />
            <span>{title}</span>
            <TimesIcon onClick={action} style={{ cursor: 'pointer' }} />
        </div>
    );
};

export default Tag;
